module.exports = __webpack_public_path__ + "img/new.e4ac3dc0.png";